import React from "react";
import {
  Form,
  Input,
  message,
  Select,
  Button,
  Space,
  Tag,
  Avatar,
  Row,
  Col,
  Dropdown,
  Modal,
  Upload,
  Tooltip,
  Switch,
  DatePicker
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

import {
  EditFilled,
  PlusOutlined,
  UserOutlined,
  DownOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import creditStore from "../store/CreditStore";
import DistributorStore from "../store/DistributorStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import config from "../config";
const { RangePicker } = DatePicker;




class CreditRequest extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
   
    this.creditStore = new creditStore(this);
    this.distributorStore = new DistributorStore(this);

  
   
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      customerCompId:"",
      creditType:"",
      sendInvoice:"",
      distributor: "",
      distCompanyId: null,
      distributorType: "",
      status: "",
      company_name: "",
      companyVal_Lab: "",
      emailId: "",
      listUpdated: 0,
     
    
      companyId: "",
      editType:"",
      dType: "",
      isadmin: "",
   
      email: "",

      creditType:"",

      createdBy: "",

      openAccountForm: false,
      companyIdForEdit: "",
      listDataUpdate: false,
      showStatusConfirm: false,
      isActive: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      
    };
  


    this.columns = [
      {
        // title: "Account Name",
        title: context.translate("_COMPANY_NAME_"),
        dataIndex: "companyDetails",
        width: "15%",
        ellipsis: true,
      },
      {
        title: context.translate("_CONTACT_"),
        dataIndex: "contactNo",
        width: "15%",
        ellipsis: true,
      },
      {
        // title: "Contact Phone",
        title: context.translate("_MAILID_"),
        dataIndex: "emailId",
        width: "15%",
        ellipsis: true,
      },
       {
        // title: "Contact Phone",
        title: context.translate("_NO_OF_CREDITS_"),
        dataIndex: "credits",
        width: "15%",
        ellipsis: true,
      },
       {
        // title: "Contact Phone",
        title: context.translate("_SERVICE_TYPE_"),
        dataIndex: "serviceType",
        width: "15%",
        ellipsis: true,
      },
       {
        // title: "Contact Phone",
        title: context.translate("_PAYMENT_METHOD_"),
        dataIndex: "paymentMethod",
        width: "15%",
        ellipsis: true,
      },
      {
        // title: "Contact Phone",
        title: context.translate("_REQUESTED_AT_"),
        dataIndex: "paymentDate",
        width: "15%",
        ellipsis: true,
      },
    ];
  

    
  }

  
  async onDateTimeChange(dates){
    console.log(dates);
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
     await this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  }  
  


  async componentDidUpdate(prvProp, prevState) {
    
  }

  async componentDidMount() {
    
    if (Number(this.props.getUserData().isadmin) !== -1) {
      this.setState({ companyId: this.props.getUserData().userCompanyId });
    }
    

    await this.distributorStore.distributorList();
    await this.setState({ listUpdated: 1 }); //need to reload data

    this.setState({ pageSize: 50 });
   }
 

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    console.log(pagination, "paadsadsfsg");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch({
      distCompanyId: null,
      creditType:null
    });
  }



 



  async handleSearch() {
    //console.log(distCompanyId)
    this.setState({ loading: true });
 
    
    await this.creditStore.searchCreditRequest({
      offset:(this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      fromDate: this.state.fromDate,
      toDate :this.state.toDate
     
      // companyId: 358,
    });
   
    await this.setState({ listUpdated: 1 }); //need to reload data
  }


  

  
  



  render() {
    //console.log('in render1')
 
    return (
      <>
        <div style={{ padding: 0 }}>
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
            <Row className="headerFixed" style={{ height: "50px" }}>
              <Col span={12}>
                {/* <div className="heading">Account List</div> */}
                <div className="heading">
                  {this.context.translate("_CREDIT_REQUEST_LIST_")}
                </div>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Space style={{}}>
                  {/* <AddButton
                link="/useradd"
                title={this.context.translate("_ADD_")}
              /> */}

                  <Space
                    style={{
                      float:
                        this.context.locale.direction == "ltr"
                          ? "right"
                          : "left",
                    }}
                  >
                    {/* <AddButton
                  link="/addaccount"
                  title={this.context.translate("_ADD_")}
                /> */}
                   <Button type="primary"
                   
                     onClick={() =>
                            
                          this.props.navigate('/creditlist')
                     }
                   >
                                        <i class="bi bi-credit-card-2-back-fill"
                                          style={{ marginRight: "5px" }}
                                        ></i>

                                      
                                        {this.context.translate("_CREDIT_LIST_")}
                                      </Button>
                     <Button type="primary"
                                      
                                        onClick={() =>
                                               
                                             this.props.navigate('/creditdetails')
                                        }
                                      >
                                                           <i class="bi bi-credit-card-2-back-fill"
                                                             style={{ marginRight: "5px" }}
                                                           ></i>
                   
                                                         
                                                           {this.context.translate("_CREDIT_DETAILS_")}
                                                         </Button>               
                  
                  </Space>
                </Space>
              </Col>
            </Row>
          )}
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
            <Row className="listInputRow">
              <Col span={16}>
                <Space>
                
                                   <RangePicker
                                                    placeholder={[
                                                      this.context.translate("_FROM_DATE_TIME_"),
                                                      this.context.translate("_TO_DATETIME_"),
                                                    ]}
                                                    format="DD-MM-YYYY hh:mmA"
                                                    style={{ width: 400 }}
                                                    onChange={(val) => {
                                                      this.onDateTimeChange(val);
                                                    }}
                                                    disabledDate={(current) => {
                                                      return current && current > dayjs();
                                                    }}
                                                    showTime={{
                                                      format: "h:mmA",
                                                      defaultValue: [dayjs().startOf("day"), dayjs()],
                                                    }}
                                                    defaultValue={[dayjs().startOf("day"), dayjs()]}
                                                  />
                                  <Button
                                                    type="primary"
                                                    onClick={async (pagination) => {
                                                      await this.setState({ pageSize: 50, current: 1 });
                                                     // await this.handleSearch();
                                                      // this.handleTableChange();
                                                      await this.handleSearch();
                                                    }}
                                                  >
                                                    {/* Show */}
                                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                                  </Button>
                
                                  
                                </Space>

                
              </Col>
            </Row>
          )}
          <ListTable
            currentPage={this.state.currentPage}
            total={this.creditStore?.total}
            columns={this.columns}
            dataSource={this.creditStore?.credits}
            pageSize={this.state.pageSize}
            // pagination={{

            //   total:this.creditStore.total || 0

            // }}
            loading={this.creditStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

       
      </>
    );
  }
}
CreditRequest.contextType = StoreContext;
export default observer(withRouter(CreditRequest));
